import { toCurrencyTruncated } from '@simplywallst/formatting';
import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
import type { LocationState } from 'redux-first-router';
import { pathConstructor } from '@/hooks/useCompany/utils';
interface ReduxState {
  company: CompanyState;
  location: LocationState;
}

export function selector(state: ReduxState) {
  try {
    const path = pathConstructor(state.location);
    const companyId = state.company.urlToIdMapping[path];
    const analysis = state.company.analysis[companyId];
    const formatting = state.company.formatting[companyId];
    const summary = state.company.summary[companyId];
    const secondaryListingExchangeRate =
      formatting.secondaryListingExchangeRate;
    const revenueEntry = analysis.legacyChartData.pastRevenueActuals.length
      ? analysis.legacyChartData.pastRevenueActuals[
          analysis.legacyChartData.pastRevenueActuals.length - 1
        ]
      : [0, 0];

    const earningsEntry = analysis.legacyChartData.pastNetIncome.length
      ? analysis.legacyChartData.pastNetIncome[
          analysis.legacyChartData.pastNetIncome.length - 1
        ]
      : [0, 0];

    const rawMarketCap = analysis.marketCapRawData.listing;
    const rawRevenue =
      (revenueEntry[1] / secondaryListingExchangeRate) * 1_000_000;
    const rawEarnings =
      (earningsEntry[1] / secondaryListingExchangeRate) * 1_000_000;
    const revenuePercentile = rawRevenue / rawMarketCap;
    const earningsPercentile = rawEarnings / rawMarketCap;
    return {
      tickerSymbol: summary.tickerSymbol,
      companyName: summary.shortName,
      rawMarketCap,
      rawRevenue,
      rawEarnings,
      revenueEndAngle: Math.PI * 2 * revenuePercentile,
      earningsEndAngle: Math.PI * 2 * earningsPercentile,
      formattedMarketCap:
        rawMarketCap > 0
          ? toCurrencyTruncated(
              rawMarketCap,
              2,
              formatting.tradingItemCurrencyISO
            )
          : 'n/a',
      formattedRevenue:
        rawRevenue > 0
          ? toCurrencyTruncated(
              rawRevenue,
              2,
              formatting.tradingItemCurrencyISO
            )
          : 'n/a',
      formattedEarnings: toCurrencyTruncated(
        rawEarnings,
        2,
        formatting.tradingItemCurrencyISO
      ),
    };
  } catch (e) {
    /** means it's loading */
    return {
      tickerSymbol: '',
      companyName: 'company',
      rawMarketCap: 0,
      rawRevenue: 0,
      rawEarnings: 0,
      revenueEndAngle: 0,
      earningsEndAngle: 0,
      formattedMarketCap: 'n/a',
      formattedRevenue: 'n/a',
      formattedEarnings: 'n/a',
    };
  }
}
